type DeliveryCityArchiveAction = 'archive' | 'restore';

type ConfirmDialogContent = {
  title: string;
  description: (deliveryCityName: string) => string;
  confirmLabel: string;
};

export const DELIVERY_CITY_CONFIRM_DIALOG_CONTENT: Record<DeliveryCityArchiveAction, ConfirmDialogContent> = {
  archive: {
    title: 'Archiver la ville de livraison',
    description: (deliveryCityName) =>
      `La ville « ${deliveryCityName} » sera retirée des listes et des formulaires de commande de l'admin, et pourra être restaurée. Le site client continuera de proposer ses créneaux tant qu'ils existent : videz-les pour arrêter les livraisons.`,
    confirmLabel: 'Archiver',
  },
  restore: {
    title: 'Restaurer la ville de livraison',
    description: (deliveryCityName) => `La ville « ${deliveryCityName} » reviendra inactive.`,
    confirmLabel: 'Restaurer',
  },
};
